/* eslint-disable ember/no-classic-components */
import Component, { setComponentTemplate } from "@ember/component";
import { tagName } from "@ember-decorators/component";
import { precompileTemplate } from "@ember/template-compilation";
const ErrorsCollection = dt7948.c(class ErrorsCollection extends Component {
  static {
    setComponentTemplate(precompileTemplate("\n    {{#if this.collection.content}}\n      <ul class=\"select-kit-errors-collection\">\n        {{#each this.collection.content as |item|}}\n          <li class=\"select-kit-error\">{{item}}</li>\n        {{/each}}\n      </ul>\n    {{/if}}\n  ", {
      strictMode: true
    }), this);
  }
}, [tagName("")]);
export default ErrorsCollection;